import { withTitle } from '../components/HOCs/withTitle'
import Home from '../components/presentation/Home'
import { pageMetadata } from '../utilities/pageMetadata'

const title = pageMetadata.home.getTitle()

export default withTitle(Home, title)
